module.exports = __webpack_public_path__ + "img/kendall.114ccd33.jpg";